import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

/**
 * Drawn with strokes, so its line weight can be changed like the other navigation icons (see `getSideBarIconSx`).
 * `AlertTriangleOutlineIcon` is the same glyph drawn as filled shapes, whose line weight is fixed.
 */
export const AlertTriangleLineIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="AlertTriangleLineIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="icon/alert-triangle/line">
            <path
                fill="none"
                d="M12 9v4M12 17h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
            </path>
        </g>
    </SvgIcon>
)
